import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import Swal from 'sweetalert2';
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rewardlist: [],
            activePage: 1,
            isActive: false,
            categorylist: [],
            activeTab: 1,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            pagecount: 1,
            username: "",
            userid: null,
            showpass: true,
            point: 0,
            balance: 0,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            token: window.localStorage.getItem("token"),
            type: "",
            linelink: "",
            amount: "",
            remark: "",
            name: "",
            password: "",
            left: false
        };

        this.login = this.login.bind(this);
    }

    async componentDidMount() {
        this.checklogin();

        try {
            await instance.post("/api/v1/mainsetting", {
                System: Systems
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message || [];

                    this.setState({
                        linelink: datas?.[1]?.value || "",
                        System: res.data?.tblcatagoryx?.[0]?.System || Systems
                    });
                }
            });
        } catch (error) {
            console.log("[MAINSETTING_ERROR]", error);
        }
    }

    checklogin = () => {
        try {
            const token = localStorage.getItem('auth_token') || localStorage.getItem('token');

            if (!token) {
                this.setState({
                    loginstate: false,
                    userid: null,
                    username: "",
                    firstname: null,
                    lastname: null,
                    point: 0,
                    balance: 0
                });

                return false;
            }

            const decoded = jwt_decode(token);
            const user = decoded?.message || {};

            this.setState({
                userid: user.member_id || user.userid || null,
                username: user.playerid || user.username || "",
                firstname: user.firstname || null,
                lastname: user.lastname || null,
                point: user.Point || 0,
                balance: user.balance || 0,
                loginstate: true
            });

            return true;
        } catch (err) {
            console.log("[CHECK_LOGIN_ERROR]", err);

            localStorage.removeItem("auth_token");
            localStorage.removeItem("token");

            this.setState({
                loginstate: false,
                userid: null,
                username: "",
                firstname: null,
                lastname: null,
                point: 0,
                balance: 0
            });

            return false;
        }
    };

    changepass = (e) => {
        e.preventDefault();

        this.setState({
            showpass: !this.state.showpass
        });
    };

    login = async (e) => {
        e.preventDefault();
        await this.validateLoginForm();
    };

    validateLoginForm = async () => {
        const username = String(this.state.username || "").trim();
        const password = String(this.state.password || "").trim();

        if (!username) {
            await this.notify("warning", "กรุณากรอกยูสเซอร์เนม");
            return false;
        }

        if (!password) {
            await this.notify("warning", "กรุณากรอกรหัสผ่าน");
            return false;
        }

        if (this.state.loading) {
            return false;
        }

        this.setState({
            loading: true
        });

        await instance.post("/api/v1/userlogin", {
            userid: username,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
        }).then(async (res) => {
            console.log("[LOGIN_RESPONSE]", res.data);

            if (res.data.status === 200) {
                localStorage.setItem('auth_token', res.data.token);

                this.setState({
                    userid: res.data.message.member_id,
                    username: res.data.message.playerid,
                    firstname: res.data.message.firstname,
                    lastname: res.data.message.lastname,
                    point: res.data.message.Point,
                    balance: res.data.databalance || res.data.balance || 0,
                    loginstate: true
                });

                await this.notify("success", "เข้าสู่ระบบสำเร็จ กำลังเปลี่ยนเส้นทาง");

                setTimeout(() => {
                    window.location.href = '/';
                }, 1200);

                return true;
            }

            await Swal.fire({
                title: 'error!',
                text: res.data.message || 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                icon: 'error',
                confirmButtonText: 'ตกลง'
            });

            return false;
        }).catch(async (err) => {
            console.log("[LOGIN_ERROR]", err);

            await Swal.fire({
                title: 'error!',
                text: 'ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง',
                icon: 'error',
                confirmButtonText: 'ตกลง'
            });

            return false;
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    notify = async (mode, msg) => {
        if (mode === "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        } else if (mode === "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        } else if (mode === "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        } else {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        }

        await this.waitnotify();
    };

    waitnotify = async () => {
        setTimeout(() => {
            console.log('World!');
        }, 5000);
    };

    onChange = (event) => {
        let nam;
        let val;

        if (event.target.name === undefined) {
            nam = event.name;
            val = event.value;
        } else {
            nam = event.target.name;
            val = event.target.value;
        }

        this.setState({
            [nam]: val
        });
    };

    render() {
        return (
            <>
                <ToastContainer />

                <div
                    className="standard-normal-font-size body-content-container"
                    data-radium="true"
                    style={{}}
                >
                    <div className="login-main-container" style={{}}>
                        <div className="login-title">ลงชื่อเข้าใช้</div>

                        <div className="login">
                            <div className="left">

                                <div className="external-break-line">
                                    <div className="break-line" />
                                    <span>หรือ</span>
                                    <div className="break-line" />
                                </div>

                                <form
                                    className="login-form standard-form-container"
                                    onSubmit={this.login}
                                >
                                    <div className="standard-form-field">
                                        <label className="standard-label standard-mandatory standard-form-col-100">
                                            ยูสเซอร์เนม
                                        </label>

                                        <div className="blue-boder standard-form-field-wrapper">
                                            <input
                                                type="text"
                                                className="standard-input"
                                                name="username"
                                                value={this.state.username || ""}
                                                onChange={this.onChange}
                                                autoComplete="username"
                                            />

                                            <div className="login-field-image" />
                                        </div>
                                    </div>

                                    <div className="standard-form-field">
                                        <label className="standard-label standard-mandatory standard-form-col-100">
                                            รหัสผ่าน
                                        </label>

                                        <div className="standard-form-field-wrapper">
                                            <div className="blue-boder standard-form-field">
                                                <input
                                                    className="standard-input"
                                                    type={this.state.showpass ? "password" : "text"}
                                                    name="password"
                                                    value={this.state.password || ""}
                                                    onChange={this.onChange}
                                                    autoComplete="current-password"
                                                />

                                                <div className="login-field-image" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="turnstile-widget-login" />

                                    <div className="login-button-section">
                                        <div className="standard-button-container login-btn-container">
                                            <button
                                                id=""
                                                className="standard-submit-form-button"
                                                data-button-category="submit"
                                                type="submit"
                                                disabled={this.state.loading}
                                            >
                                                <span>
                                                    {this.state.loading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="forget-password-container">
                                        <span>ลืม </span>
                                        <a href="/register" style={{ cursor: 'pointer', color: '#009bd8' }}>ยูสเซอร์เนม </a>
                                        <span> หรือ </span>
                                        <a href="/register" style={{ cursor: 'pointer', color: '#009bd8' }}>รหัสผ่าน</a>?
                                    </div>

                                    <div className="prompt-create">
                                        <p>
                                            ยังไม่มีบัญชีใช่หรือไม่? <a href="/register" style={{ color: '#009bd8' }}>สร้างบัญชี</a>
                                        </p>
                                    </div>

                                    <div className="break-line" />

                                    <div className="help-container">
                                        <p>
                                            หากคุณพบปัญหาใด ๆ ขณะเข้าสู่ระบบ, กรุณาติดต่อ
                                            {this.state.linelink
                                                ? <a href={`https://line.me/ti/p/${this.state.linelink}`} target="_blank" rel="noreferrer" style={{ color: '#009bd8' }}> เจ้าหน้าที่ฝ่ายบริการลูกค้า </a>
                                                : <a href="/register" style={{ color: '#009bd8' }}> เจ้าหน้าที่ฝ่ายบริการลูกค้า </a>
                                            }
                                            เพื่อขอความช่วยเหลือเพิ่มเติม
                                        </p>
                                    </div>
                                </form>
                            </div>

                            <div className="right">
                                <div className="content-container">
                                    <div className="login-banner-container">
                                        <div className="slick-slider slider slick-initialized">
                                            <div className="slick-list">
                                                <div
                                                    className="slick-track"
                                                    style={{
                                                        opacity: 1,
                                                        transform: "translate3d(0px, 0px, 0px)",
                                                        width: 623
                                                    }}
                                                >
                                                    <div
                                                        data-index={0}
                                                        className="slick-slide slick-active slick-current"
                                                        tabIndex={-1}
                                                        aria-hidden="false"
                                                        style={{ outline: "none", width: 623 }}
                                                    >
                                                        <div>
                                                            <div className="image-container">
                                                                <span
                                                                    className="global-placeholder lazy-load-image-background lazy-load-image-loaded"
                                                                    style={{
                                                                        color: "transparent",
                                                                        display: "inline-block"
                                                                    }}
                                                                >
                                                                    <img
                                                                        loading="lazy"
                                                                        src="https://s3.newworld.center/image/a6b8098f-0d67-4313-b6d2-9b86db81bb92.webp"
                                                                        className="slider-banner"
                                                                        alt="banner"
                                                                        id="slider-banner-0"
                                                                        style={{ width: "100%" }}
                                                                    />
                                                                </span>

                                                                <div className="banner-content">
                                                                    <div className="custom-desc-container" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="login-banner-container">
                                        <div className="slick-slider slider slick-initialized">
                                            <div className="slick-list">
                                                <div
                                                    className="slick-track"
                                                    style={{
                                                        opacity: 1,
                                                        width: 623
                                                    }}
                                                >
                                                    <div
                                                        data-index={0}
                                                        className="slick-slide slick-active slick-current"
                                                        tabIndex={-1}
                                                        aria-hidden="false"
                                                        style={{
                                                            outline: "none",
                                                            width: 623,
                                                            position: "relative",
                                                            left: 0,
                                                            opacity: 1,
                                                            transition: "opacity 500ms, visibility 500ms"
                                                        }}
                                                    >
                                                        <div>
                                                            <div className="image-container">
                                                                <div className="banner-content">
                                                                    <div className="custom-desc-container">
                                                                        <div className="custom-views">
                                                                            <div
                                                                                className="member-benefit-column-container"
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    margin: "0.25rem 0px 0.4rem",
                                                                                    textAlign: "center"
                                                                                }}
                                                                            >
                                                                                <div>
                                                                                    <div className="list-item">
                                                                                        <div
                                                                                            className="pointer-item"
                                                                                            style={{
                                                                                                color: "rgb(15, 22, 31)",
                                                                                                fontFamily: "sukhumvitset",
                                                                                                fontSize: "0.3rem",
                                                                                                fontWeight: 700
                                                                                            }}
                                                                                        >
                                                                                            <div>PK8 Gresini Racing MotoGP 2026</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="info" />
                                    <div className="info-logo" />

                                    <div className="license-container">
                                        <p>
                                            ได้รับใบอนุญาตและอยู่ภายใต้การกำกับดูแลของรัฐบาลเกาะอิสระอันจูอัน
                                            สหภาพโคโมโรส
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default App;